// extracted by mini-css-extract-plugin
export default {"title":"notFound_title__Eivfd"};